module.exports = __webpack_public_path__ + "static/enzyme_grey-8b32cf67a7f92ee7757d13afee270421.png";